export default __webpack_public_path__ + "static/media/dream-joystick-bridge_1.0.0_arm.66b6c262.exe";